import {
  GET_LABREQUESTDELIVERYRESULTPARTIAL,
  GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  GET_LABREQUESTDELIVERYRESULTPARTIALS,
  GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL,
  GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS,
  ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL,
  ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL,
  payload: loading,
})

export const getLabRequestDeliveryResultPartials = ( params ) => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIALS,
  payload: { params },
})

export const getLabRequestDeliveryResultPartialsSuccess = (labRequestDeliveryResultPartials, totalPages, currentPage) => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS,
  payload: { labRequestDeliveryResultPartials:labRequestDeliveryResultPartials, total:totalPages, currentPage:currentPage}
})

export const getLabRequestDeliveryResultPartialsFail = error => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL,
  payload: error,
})

export const addNewLabRequestDeliveryResultPartial = labRequestDeliveryResultPartial => ({
  type: ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL,
  payload: labRequestDeliveryResultPartial,
})

export const addLabRequestDeliveryResultPartialSuccess = labRequestDeliveryResultPartial => ({
  type: ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  payload: labRequestDeliveryResultPartial,
})  

export const addLabRequestDeliveryResultPartialFail = error => ({
  type: ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  payload: error,
})

export const updateLabRequestDeliveryResultPartial = labRequestDeliveryResultPartial => ({
  type: UPDATE_LABREQUESTDELIVERYRESULTPARTIAL,
  payload: labRequestDeliveryResultPartial,
})

export const updateLabRequestDeliveryResultPartialSuccess = labRequestDeliveryResultPartial => ({
  type: UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  payload: labRequestDeliveryResultPartial,
})

export const updateLabRequestDeliveryResultPartialFail = error => ({
  type: UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  payload: error,
})

export const deleteLabRequestDeliveryResultPartial = labRequestDeliveryResultPartial => ({
  type: DELETE_LABREQUESTDELIVERYRESULTPARTIAL,
  payload: labRequestDeliveryResultPartial,
})

export const deleteLabRequestDeliveryResultPartialSuccess = id => ({
  type: DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  id,
})

export const deleteLabRequestDeliveryResultPartialFail = error => ({
  type: DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  payload: error,
})

export const getLabRequestDeliveryResultPartial = () => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIAL,
})

export const getLabRequestDeliveryResultPartialSuccess = labRequestDeliveryResultPartial => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  payload: labRequestDeliveryResultPartial,
})

export const getLabRequestDeliveryResultPartialFail = error => ({
  type: GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  payload: error,
})
